export default {
      id: "flex-alignContent-space-between-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignContent-space-between-usage",
      toString: function () {
        return this.url;
      }
    }